import { Pipe, PipeTransform } from '@angular/core';
import { isValidEmail } from '../utils/email-validator';

@Pipe({
  name: 'isValidEmail',
  standalone: true
})
export class EmailValidatorPipe implements PipeTransform {
  transform(email: string): boolean {
    return isValidEmail(email);
  }
} 